module.exports = __webpack_public_path__ + "static/img/10.9968bb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/eng/10.png
// module id = 4LgJ
// module chunks = 0